/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Fix aria-hidden focusable descendants in carousels
document.addEventListener('DOMContentLoaded', function() {
  
  // Function to manage focusable elements in carousel items
  function manageFocusableElements() {
    // Find all product items with aria-hidden attribute
    var productItems = document.querySelectorAll('.product-item[aria-hidden]');
    
    productItems.forEach(function(item) {
      var isHidden = item.getAttribute('aria-hidden') === 'true';
      // Find all focusable elements (links, buttons, inputs, etc.)
      var focusableElements = item.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      
      focusableElements.forEach(function(element) {
        if (isHidden) {
          // Store original tabindex if it exists
          if (!element.hasAttribute('data-original-tabindex')) {
            var originalTabindex = element.getAttribute('tabindex');
            if (originalTabindex) {
              element.setAttribute('data-original-tabindex', originalTabindex);
            }
          }
          // Make unfocusable
          element.setAttribute('tabindex', '-1');
        } else {
          // Restore focusability
          if (element.hasAttribute('data-original-tabindex')) {
            element.setAttribute('tabindex', element.getAttribute('data-original-tabindex'));
            element.removeAttribute('data-original-tabindex');
          } else {
            element.removeAttribute('tabindex');
          }
        }
      });
    });
  }
  
  // Run on page load
  manageFocusableElements();
  
  // Watch for changes to aria-hidden attributes (when carousel slides change)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        manageFocusableElements();
      }
    });
  });
  
  // Observe all product lists for aria-hidden changes
  var productLists = document.querySelectorAll('.product-list, .flickity-viewport, [data-section-type*="collection"]');
  productLists.forEach(function(list) {
    observer.observe(list, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  });
  
  // Also run after a short delay to catch any dynamically loaded content
  setTimeout(manageFocusableElements, 1000);
});
// Track Add to Cart events for GA4
document.addEventListener('product:added', function(event) {
  var variant = event.detail.variant;
  var quantity = event.detail.quantity || 1;
  
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: variant.currency || 'USD',
      value: (variant.price / 100) * quantity,
      items: [{
        item_id: variant.sku || variant.id,
        item_name: variant.product_title || variant.name,
        item_variant: variant.title,
        price: variant.price / 100,
        quantity: quantity
      }]
    }
  });
});
// Optimize Willdesk font loading with font-display: swap
(function() {
  var style = document.createElement('style');
  style.textContent = '@font-face{font-family:"Inter";font-style:normal;font-weight:400;font-display:swap;src:url(https://img.willdesk.com/fonts/ttf/Inter-Regular.ttf) format("truetype")}';
  
  // Insert early to override Willdesk's font loading
  if (document.head.firstChild) {
    document.head.insertBefore(style, document.head.firstChild);
  } else {
    document.head.appendChild(style);
  }
})();

// Fix brand filter in search
document.addEventListener('DOMContentLoaded', function() {
  const vendorSelect = document.getElementById('search-product-vendor');
  
  if (vendorSelect) {
    vendorSelect.addEventListener('change', function() {
      const searchForm = this.closest('form');
      const searchInput = searchForm.querySelector('.search-bar__input');
      
      // Update the label
      const label = this.closest('.search-bar__filter').querySelector('.search-bar__filter-active');
      label.innerText = this.options[this.selectedIndex].innerText;
      
      // Add vendor filter to search
      if (this.value) {
        searchInput.value = 'vendor:' + this.value + (searchInput.value ? ' ' + searchInput.value : '');
      }
      
      // Trigger search if there's input
      if (searchInput.value) {
        searchForm.submit();
      }
    });
  }
});

// Fix category filter in search
document.addEventListener('DOMContentLoaded', function() {
  const categorySelect = document.getElementById('search-product-type');
  
  if (categorySelect) {
    categorySelect.addEventListener('change', function() {
      const searchForm = this.closest('form');
      const searchInput = searchForm.querySelector('.search-bar__input');
      
      // Update the label
      const label = this.closest('.search-bar__filter').querySelector('.search-bar__filter-active');
      label.innerText = this.options[this.selectedIndex].innerText;
      
      // Add category filter to search
      if (this.value) {
        searchInput.value = 'product_type:' + this.value + (searchInput.value ? ' ' + searchInput.value : '');
      }
      
      // Trigger search if there's input
      if (searchInput.value) {
        searchForm.submit();
      }
    });
  }
});


// Rotating search placeholder (uses theme settings)
document.addEventListener('DOMContentLoaded', function() {
  const searchInputs = document.querySelectorAll('.search-bar__input');

  if (searchInputs.length > 0) {
    // Get placeholders from window (will be set by Liquid in theme.liquid)
    const placeholders = window.searchPlaceholders || [
      'Search by part number...',
      'Search by brand...',
      'Search by product type...'
    ];

    let currentIndex = 0;

    searchInputs.forEach(function(input) {
      // Set initial placeholder
      input.setAttribute('placeholder', placeholders[0]);

      // Don't rotate if user is focused on input
      let isUserFocused = false;

      input.addEventListener('focus', function() {
        isUserFocused = true;
      });

      input.addEventListener('blur', function() {
        isUserFocused = false;
      });

      // Rotate placeholder every 3 seconds
      setInterval(function() {
        if (!isUserFocused && input.value === '') {
          currentIndex = (currentIndex + 1) % placeholders.length;
          input.setAttribute('placeholder', placeholders[currentIndex]);
        }
      }, 3000);
    });
  }
});
